import { Button, Popover } from 'antd';
import Icon from '@ant-design/icons';
import { MouseEvent, useCallback } from 'react';
import { EyeOff } from '../../../../../Common/Icon';
import { COLORS } from '../../../../../../utils/cssUtils';
import Customize from '../Customize';
import SectionsList from '../../SectionsList';

const CustomizePopover = () => {

  const handleMouseEnter = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.borderColor = COLORS.White;
    e.currentTarget.style.color = COLORS.White;
  }, []);

  const handleMouseLeave = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.borderColor = COLORS.BorderGrey;
    e.currentTarget.style.color = COLORS.BorderGrey;
  }, []);

  return (
    <Popover
      placement="bottomRight"
      trigger="click"
      showArrow={false}
      content={
        <div style={{ display: 'flex', gap: '20px' }}>
          <Customize />
          <SectionsList />
        </div>
      }
    >
      <Button
        ghost
        type="default"
        size="large"
        icon={<Icon component={EyeOff}/>}
        style={{
          borderColor: COLORS.BorderGrey,
          color: COLORS.BorderGrey,
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        Customize
      </Button>
    </Popover>
  )
}

export default CustomizePopover;
